import React from "react";
import aboutus from "../../img/aboutus.jpg";
export default function Aboutus() {
  return (
    <>
      <section id="about" className="about section-bg">
        <div className="container" data-aos="fade-up">
          <div className="section-title">
            <h2>About</h2>
            <h3>
              Find Out More <span>About Us</span>
            </h3>
            <p>
              This Website is aimed to developing an online application for the
              placement department of college.
            </p>
          </div>

          <div className="row">
            <div
              className="col-lg-6"
              data-aos="fade-right"
              data-aos-delay="100"
            >
              <img
                src={aboutus}
                className="mb-4 mb-lg-0 contact-img rounded float-left img-fluid"
                alt=""
              ></img>
            </div>
            <div
              className="col-lg-6 pt-4 pt-lg-0 content d-flex flex-column justify-content-center"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <h3>
                Campus Selection System aims in providing the compatibilty to
                simplify the process of placement for student
              </h3>
              {/* <p className="fst-italic">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua.
              </p> */}
              <ul>
                <li>
                  <i className="bx bx-images"></i>
                  <div>
                    <h5>What company can do</h5>
                    <p>
                      Company can upload all the information like what students
                      they are looking for , pacakge , they can mention the CGPA
                      criteria then only those students whose CGPA criteria is
                      passed they can only apply fre the company
                    </p>
                  </div>
                </li>
                <li>
                  <i className="bx bx-store-alt"></i>
                  <div>
                    <h5>Administrator has power to view anything</h5>
                    <p>
                      The Administrator can view student prifiles and the
                      companies that visited . He can remove faulty accounts as
                      well as . All the data like which company has given how
                      much package , how many students they picked , from which
                      department , etc
                    </p>
                  </div>
                </li>
              </ul>
              <p>
                This system has a big scope to do. students can maintain their
                information . Notification are sent to students email address
                about the companies . Students can access the previous
                information about recruitmen.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
